(function() {
  // Přidání stylů - pouze jednou
  function addStyles() {
    if (document.getElementById('read-more-styles')) return;
    
    const style = document.createElement('style');
    style.id = 'read-more-styles';
    style.textContent = `
      .read-more-btn, .read-less-btn {
        color: #0066cc;
        cursor: pointer;
        text-decoration: none;
        font-weight: 500;
        display: inline-block;
        margin-left: 3px;
      }
      .read-more-btn:hover, .read-less-btn:hover {
        text-decoration: underline;
      }
      /* Barva šipky se mění podle barvy tlačítka - naprosto stejné barvy */
      .read-more-btn .arrow-down {
        border-top-color: currentColor;
      }
      .read-less-btn .arrow-up {
        border-bottom-color: currentColor;
      }
      .read-less-btn {
        display: block;
        margin-top: 10px;
      }
      .arrow-down {
        display: inline-block;
        margin-left: 3px;
        border-left: 5px solid transparent;
        border-right: 5px solid transparent;
        border-top: 5px solid currentColor;
        vertical-align: middle;
      }
      .arrow-up {
        display: inline-block;
        margin-left: 3px;
        border-left: 5px solid transparent;
        border-right: 5px solid transparent;
        border-bottom: 5px solid currentColor;
        vertical-align: middle;
      }
    `;
    document.head.appendChild(style);
  }

  // Funkce pro zpracování jednoho popisu
  function processDescription(description) {
    // Kontrola, zda už byl zpracován
    if (description.getAttribute('data-processed')) {
      return;
    }
    
    // Uložit původní obsah
    const originalContent = description.innerHTML;
    
    // Kontrola, zda je obsah dostatečně dlouhý
    if (description.textContent.length <= 160) {
      // Označit jako zpracovaný, aby se s ním už nepracovalo
      description.setAttribute('data-processed', 'true');
      return;
    }
    
    // Vytvořit zkrácený text
    let shortText = "";
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = originalContent;
    
    // Efektivní extrakce prvních 300 znaků textu
    function getFirstNChars(element, n) {
      let text = "";
      
      function traverse(node) {
        if (text.length >= n) return;
        
        if (node.nodeType === 3) { // Text node
          text += node.textContent;
        } else if (node.nodeType === 1) { // Element node
          for (let child of node.childNodes) {
            traverse(child);
            if (text.length >= n) break;
          }
        }
      }
      
      traverse(element);
      return text.substring(0, n);
    }
    
    shortText = getFirstNChars(tempDiv, 160);
    
    // Generovat unikátní ID - efektivnější než náhodná čísla
    const uniqueId = 'desc-' + (description.id || Date.now()) + '-' + Math.floor(Math.random() * 1000);
    
    // Vytvořit DOM elementy místo manipulace s innerHTML - efektivnější
    const fragment = document.createDocumentFragment();
    
    // Krátký popis
    const shortDescDiv = document.createElement('div');
    shortDescDiv.id = 'short-' + uniqueId;
    shortDescDiv.textContent = shortText + '... ';
    
    // Tlačítko "zobrazit více"
    const readMoreBtn = document.createElement('a');
    readMoreBtn.href = '#';
    readMoreBtn.className = 'read-more-btn';
    readMoreBtn.textContent = 'Zobrazit více informací ';
    
    const arrowDown = document.createElement('span');
    arrowDown.className = 'arrow-down';
    readMoreBtn.appendChild(arrowDown);
    
    shortDescDiv.appendChild(readMoreBtn);
    fragment.appendChild(shortDescDiv);
    
    // Plný popis
    const fullDescDiv = document.createElement('div');
    fullDescDiv.id = 'full-' + uniqueId;
    fullDescDiv.style.display = 'none';
    fullDescDiv.innerHTML = originalContent;
    
    // Tlačítko "skrýt"
    const readLessBtn = document.createElement('a');
    readLessBtn.href = '#';
    readLessBtn.className = 'read-less-btn';
    readLessBtn.textContent = 'Skrýt informace ';
    
    const arrowUp = document.createElement('span');
    arrowUp.className = 'arrow-up';
    readLessBtn.appendChild(arrowUp);
    
    fullDescDiv.appendChild(readLessBtn);
    fragment.appendChild(fullDescDiv);
    
    // Vyčistit a přidat nový obsah - jedna operace DOM
    description.innerHTML = '';
    description.appendChild(fragment);
    
    // Přidat event listenery pomocí delegace - vytvoří jen dva event listenery
    readMoreBtn.addEventListener('click', function(e) {
      e.preventDefault();
      shortDescDiv.style.display = 'none';
      fullDescDiv.style.display = 'block';
    });
    
    readLessBtn.addEventListener('click', function(e) {
      e.preventDefault();
      shortDescDiv.style.display = 'block';
      fullDescDiv.style.display = 'none';
    });
    
    // Označit jako zpracovaný
    description.setAttribute('data-processed', 'true');
  }

  // Hlavní funkce s Intersection Observer pro lazy loading
  function initReadMore() {
    addStyles();
    
    // Najít všechny popisy produktů
    const descriptions = document.querySelectorAll('.product__description, .product-description');
    
    // Pokud je na stránce jen málo produktů, zpracujeme je přímo
    if (descriptions.length <= 5) {
      descriptions.forEach(processDescription);
      return;
    }
    
    // Pro stránky s mnoha produkty použijeme Intersection Observer
    // Zpracuje popisy až když jsou blízko viditelné oblasti
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          processDescription(entry.target);
          observer.unobserve(entry.target); // Přestat sledovat po zpracování
        }
      });
    }, {
      rootMargin: '200px 0px', // Načte s předstihem 200px
      threshold: 0.01 // Stačí malá část viditelná pro spuštění
    });
    
    // Sledovat všechny popisy
    descriptions.forEach(description => {
      observer.observe(description);
    });
  }

  // Spustit inicializaci po načtení DOM
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initReadMore);
  } else {
    initReadMore();
  }
})();